import React, { useCallback,useMemo,useEffect, useRef, useState } from 'react';
import MaterialReactTable from 'material-react-table';
import { Box,
  Button,
  IconButton,
  Typography,
  Tooltip,
} from '@mui/material';
import Axios from '../../lib/axios/axiosInstance';
import { Slide, toast } from 'react-toastify';
import {FileDownloadIcon,Edit,Save,Delete,Refresh } from '@mui/icons-material';
import { Row, Col } from "react-bootstrap";
import CsvDownloadButton from 'react-json-to-csv'
import { useNavigate, Link } from 'react-router-dom';
import * as AuthVerify from '../../lib/common';

const CustomTable = ({ globalSearch=false,requestData=false}) => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [isError, setIsError] = useState(false);
  const [apiData, setApiData] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [validationErrors, setValidationErrors] = useState({});

  const [columnFilters, setColumnFilters] = useState([]);
  const [columnFilterFns, setColumnFilterFns] = useState({
    websku: 'contains',
    webskuname: 'contains',
    custsku: 'contains',
    custskuname: 'contains'
  });
  // const [initialColumnFiltersFns, setInitialColumnFilterFns] = useState({
  //   websku: 'contains',
  //   webskuname: 'contains',
  //   custsku: 'contains',
  //   custskuname: 'contains'
  // });
  const [globalFilter, setGlobalFilter] = useState('');
  const [sorting, setSorting] = useState([]);
  const tableInstanceRef = useRef(null);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 5
  });

  const fileInputRef = useRef(null);
  const mockData = useRef([]);

  const addData = (newData) =>{
    // setData((prev)=>({
    //   ...prev,
    //   newData
    // }))
    // setData(newData);
    // var message = '';
    // newData.map((item,i) => {
    //   const keys=Object.keys(item);
    //   if(!keys.includes('websku')){
    //     message+=`line ${i+2} websku field missing !\n`
    //   }
    //   if(!keys.includes('custsku')){
    //     message+=`line ${i+2} custsku field missing !\n`
    //   }
    //   if(!keys.includes('custskuname')){
    //     message+=`line ${i+2} custskuname field missing !\n`
    //   }
    // });
    // // const keys=Object.keys(newData[0]);
    // // if(!keys.includes('websku')){
    // //   return toast.warning("websku field missing !", {
    // //     position: toast.POSITION.TOP_CENTER,
    // //     autoClose: 3000,
    // //     transition: Slide,
    // //   });
    // // }
    // // else if(!keys.includes('custsku')){
    // //   return toast.warning("custsku field missing !", {
    // //     position: toast.POSITION.TOP_CENTER,
    // //     autoClose: 3000,
    // //     transition: Slide,
    // //   });
    // // }
    // if(message.length>1){
    //     return toast.warning(message, {
    //       position: toast.POSITION.TOP_CENTER,
    //       autoClose: 3000,
    //       transition: Slide,
    //     });
    // }
    // else{
      var error="";
      newData.map((element,i) => {
        if(!element.websku){
          error+=`line ${i+1} websku missing | `+'\n'
        }
        if(!element.custsku){
          error+=`line ${i+1} custsku missing | `+'\n'
        }
        if(!element.custskuname){
          error+=`line ${i+1} custskuname missing | `+'\n'
        }
      });
      if(error.length>0){
        return toast.warning(error, {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 30000,
          transition: Slide,
        });
      }
      else{
        const newMergedData = [
          ...data,
          ...newData
        ];
        // setData(newMergedData)
        // // setData(newData);
        // setRowCount(newData.length);
        // setRowCount(newMergedData.length);
        saveChangesHandler(newMergedData);
      }
    // }
  }

  const handleFile = (file) => {
    if(file){
      AuthVerify.readFileAsJson(file,addData);
      fileInputRef.current.value=null;
    }else{
      toast.warning("Please select a CSV file first !", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 3000,
        transition: Slide,
      });
    }
  };

  const downloadFile = () => {
    Axios.get('/corporate/template/productmapping')
    .then(result=>{
      if(result?.data?.data?.template){
        mockData.current=result?.data?.data?.template;
      }
    })
  };

  useEffect(()=>{
    downloadFile();
  },[])

  const handleSaveRowEdits = async ({ exitEditingMode, row, values }) => {
    if (!Object.keys(validationErrors).length) {
      data[row.index] = values;
      //send/receive api updates here, then refetch or update local table data for re-render
      setData([...data]);
      exitEditingMode(); //required to exit editing mode and close modal
    }
  };

  const handleDeleteRow = useCallback(
    (row) => {
      // if (
      //   !window.confirm(`Are you sure you want to delete ${row.getValue('firstName')}`)
      // ) {
      //   return;
      // }
      //send api delete request here, then refetch or update local table data for re-render
      data.splice(row.index, 1);
      setData([...data]);
    },
    [data],
  );

  const handleCancelRowEdits = () => {
    setValidationErrors({});
  };

  const handleDeleteRows = useCallback(
    (rows) => {
      // if (
      //   !window.confirm(`Are you sure you want to delete ${row.getValue('firstName')}`)
      // ) {
      //   return;
      // }
      //send api delete request here, then refetch or update local table data for re-render
      rows.forEach(async row => {
        const preData=row.original;
        // data.splice(row.index, 1);
        await deleteHandler(preData?.websku);
      });
      setData([...data]);
      tableInstanceRef.current.resetRowSelection();
    },
    [data],
  );

  const handleEditRows = (rows)=>{
    // dataaaa=filterItems(dataaaa,rows.map((row) => row.original)[0])
    console.log(rows.map((row) => row.original))
  }

  const findFilterCondition = (name) =>{
    var condition = '';
    if(columnFilterFns[name]){
      condition = columnFilterFns[name];
    }
    // if(condition==''){
    //   condition = initialColumnFiltersFns[name];
    // }
    return condition;
  }

  const fetchDataFromAPI = async (reset=false) => {
    if (!data.length) {
      setIsLoading(true);
    } else {
      setIsRefetching(true);
    }
    
    // console.log("tableInstanceRef",tableInstanceRef.current.getGlobalFilterFn());
    // console.log("columnFiltersFns",columnFilterFns);
    // console.log('sorting', JSON.stringify(sorting ?? []));
    // console.log('filters', JSON.stringify(columnFilters ?? []));
    // console.log('globalFilter', globalFilter ?? '');
    
    let filterQuery='';
    let sorterQuery='';

    if(!reset){
      if(columnFilters.length>0){
        columnFilters.forEach(element => {
          filterQuery+=`&filter=${element.id},${findFilterCondition(element.id)},${element.value}`;
        });
      }
      if(sorting.length > 0){
        sorting.forEach(element => {
          sorterQuery+=`&sortby=${element.id}&orderby=${element.desc?'desc':'asc'}`;
        });
      }
    }else{
      setPagination({
        pageIndex: 0,
        pageSize: 5
      });
      tableInstanceRef.current.resetRowSelection();
    }
    
    const user = AuthVerify.getUser();
    let url = `/corporate/productmapping/${user.arnum}?limit=${pagination.pageSize}&offset=${pagination.pageIndex * pagination.pageSize}${sorterQuery}${filterQuery}`;
    await Axios.get(url)
      .then(function (response) {
        if (response && response.data?.data) {
          setData(response.data?.data.items.items??[]);
          setRowCount(response.data?.data.items.count);
          setIsError(false);
          setIsLoading(false);
          setIsRefetching(false);
        }
        else {
          toast.error(response.statusText ?? "Data fetching failed !", {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 3000,
            transition: Slide,
          });
        }
      })
      .catch(function (error) {
        // navigate('/');
      });
  };

  const fetchDataFromList = async () => {
    var oldData=data;
    if(!oldData.length){
      oldData=requestData; setApiData(false)
    }
    if (!data.length) {
      setIsLoading(true);
    } else {
      setIsRefetching(true);
    }
    setData(oldData);
    setRowCount(oldData.length);
    setIsError(false);
    setIsLoading(false);
    setIsRefetching(false);
  };


  useEffect(() => {
    if(requestData){
      fetchDataFromList();
    }else{
      fetchDataFromAPI();
    }
  }, [
    columnFilters,
    globalFilter,
    pagination.pageIndex,
    pagination.pageSize,
    sorting,
    requestData
  ]);

  const deleteHandler =async (websku) =>{
    if(!websku)return;
    setIsLoading(true);
    await Axios.delete(`/corporate/productmapping/${websku}`)
      .then(function (response) {
        setIsLoading(false);
        if (response && response.data?.data) {
          setData(response.data?.data.items.items??[]);
          setRowCount(response.data?.data.items.count);
          setIsError(false);
          setIsRefetching(false);
        }
        else {
          toast.error(response.statusText ?? "Data fetching failed !", {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 3000,
            transition: Slide,
          });
        }
      })
      .catch(function (error) {
        setIsLoading(false);
        // navigate('/');
      });
  }

  const saveChangesHandler =async (newMergedData) =>{
    const body = {items: newMergedData ?? data}
    setIsLoading(true);
    await Axios.post(`/corporate/productmapping/`,body)
      .then(function (response) {
        setIsError(false);
        setIsLoading(false);
        setIsRefetching(false);
        if (response && response.data?.data) {
          setData(response.data?.data.items.items??[]);
          setRowCount(response.data?.data.items.count);
        }
        else {
          var error="";
          response.data.errordetail.forEach(element => {
            var errorDetails=element.error.replaceAll('"'," ");
            errorDetails=errorDetails.replaceAll("'"," ");
            var split1=errorDetails.split("]");
            var split2=split1[0].split("[");
            var splitValue=parseInt(split2[1]);
            errorDetails = `[${splitValue+1-data?.length??0}]${split1[1]}`
            error+=errorDetails+'\n';
          });
          toast.error(error ?? "Data fetching failed !", {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 3000,
            transition: Slide,
          });
        }
      })
      .catch(function (error) {
        setIsLoading(false);
        // navigate('/');
      });
  }

  const columns = useMemo(
    () => [
      {
        accessorFn: (row) => row.websku,
        id: 'websku',
        // enableColumnFilter: false,
        // enableSorting: false,
        // enableColumnFilterModes: false,
        header: 'Webshop SKU',
        enableEditing : false,
        size:50,
        Cell: ({ cell, row }) => (
          // <a href="#">
          //   <img style={{ maxHeight: "60px" }} src={BASE_URL + cell.getValue()} alt="Product" />
          // </a>
          <Typography variant='h4'>{cell.getValue()}</Typography>
        ),
        filterFn: 'contains',
        columnFilterModeOptions: ['contains'],
      },
      {
        accessorKey: 'webskuname',
        header:  "Webshop SKU name",
        Cell: ({ cell, row }) => (
          <Typography variant='h4'>{cell.getValue()}</Typography>
        ),
        size:50,
        enableColumnFilterModes: true,
        filterFn: 'contains',
        columnFilterModeOptions: ['contains'],
      },
      {
        accessorKey: 'custsku',
        header:  "Internal SKU",
        Cell: ({ cell, row }) => (
          <Typography variant='h4'>{cell.getValue()}</Typography>
        ),
        size:50,
        enableColumnFilterModes: true,
        filterFn: 'contains',
        columnFilterModeOptions: ['contains'],
      },
      {
        accessorKey: 'custskuname',
        header: "Internal SKU name",
        Cell: ({ cell, row }) => (
          <Typography variant='h4'>{cell.getValue()}</Typography>
        ),
        size:50,
        enableColumnFilterModes: true,
        filterFn: 'contains',
        columnFilterModeOptions: ['contains'],
      }
      //end
    ],
    [],
  );

  return (
    <>
        <Col sm={12} style={{ padding: "5px 0px 10px 0px" }}>
          <Link to="#" style={{ float: "left", textDecoration: "none", fontWeight: "bold" }}>Add New</Link>

          <CsvDownloadButton delimiter={","} data={mockData.current} style={{float:"right", textDecoration:"none", fontWeight:"bold", background:"none", color:"#1890ff"}} filename="Template.csv">Download CSV Template</CsvDownloadButton>

          <button style={{float:"right", textDecoration:"none", fontWeight:"bold", background:"none", color:"#1890ff"}} onClick={()=>fileInputRef.current.click()}>Import CSV</button>
          <input accept=".xls,.xlsx,.csv" type="file" onChange={(e) => handleFile(e.target.files[0])} ref={fileInputRef} style={{ display: 'none' }} />
        </Col>
        <Row>
        </Row>
        <MaterialReactTable
          columns={columns}
          data={data}
          // enableStickyHeader
          enableColumnActions={false}
          enableGlobalFilter={false}
          enableColumnFilterModes
          initialState={{ 
            showColumnFilters: true
          }}
          manualFiltering
          manualPagination
          manualSorting
          onColumnFilterFnsChange={setColumnFilterFns}
          onColumnFiltersChange={setColumnFilters}
          onGlobalFilterChange={setGlobalFilter}
          onPaginationChange={setPagination}
          onSortingChange={setSorting}
          tableInstanceRef={tableInstanceRef} 
          rowCount={rowCount}
          enableEditing
          editingMode="row"
          onEditingRowSave={handleSaveRowEdits}
          onEditingRowCancel={handleCancelRowEdits}
          state={{
            columnFilters,
            columnFilterFns,
            globalFilter,
            isLoading,
            pagination,
            showAlertBanner: isError,
            showProgressBars: isRefetching,
            sorting,
          }}
          positionActionsColumn="last"
          displayColumnDefOptions={{
            'mrt-row-actions': {
              header: 'Action', //change header text
            },
          }}
          enableRowSelection
          renderTopToolbarCustomActions={({ row,table }) => (
            <Box
              sx={{ display: 'flex', gap: '1rem', p: '0.5rem', flexWrap: 'wrap' }}
            >
              <Button
                disabled={
                  !table.getIsSomeRowsSelected() && !table.getIsAllRowsSelected()
                }
                // onClick={() => handleExportRows(table.getSelectedRowModel().rows)}
                onClick={() => handleDeleteRows( table.getSelectedRowModel().rows)}
                startIcon={<Delete />}
                variant="contained"
                color="error"
              >
                Delete
              </Button>

              <Button
                // onClick={() => handleExportRows(table.getSelectedRowModel().rows)}
                onClick={() => fetchDataFromAPI(true)}
                startIcon={<Refresh />}
                variant="contained"
                // color="error"
              >
                Reload
              </Button>
            </Box>
          )}
          // renderRowActions={({ row, table }) => (
          //   <Box sx={{ display: 'flex', gap: '1rem' }}>
          //     <Tooltip arrow placement="left" title="Edit">
          //       <IconButton onClick={() => table.setEditingRow(row)}>
          //         <Edit />
          //       </IconButton>
          //     </Tooltip>
          //     <Tooltip arrow placement="left" title="Save">
          //       <IconButton onClick={() => table.setEditingRow(row)}>
          //         <Save />
          //       </IconButton>
          //     </Tooltip>
          //     <Tooltip arrow placement="right" title="Delete">
          //       <IconButton color="error" onClick={() => handleDeleteRow(row)}>
          //         <Delete />
          //       </IconButton>
          //     </Tooltip>
          //   </Box>
          // )}
          muiTableHeadCellProps={{
            sx: {
              // fontWeight: 'bold',
              fontSize: '15px',
            },
          }}
          muiTablePaginationProps={{
            sx: {
              fontWeight: 'bold',
              paddingTop: '12px',
              fontSize: '16px',
            },
          }}
          muiTableBodyCellEditTextFieldProps= {({ cell, column, row, table }) =>({
            sx: {
              fontSize: '17px'
            },
          })}
          muiTableHeadCellFilterTextFieldProps={{
            sx: {
              fontWeight: 'bold',
              fontSize: '17px',
            },
          }}
        />
        {/* <div className="cart_navigation">
          <button className="button btn-proceed-checkout" title="Proceed to Save the Changes" type="button" onClick={() => saveChangesHandler()}><span>Save Changes</span></button>
        </div> */}
    </>
  );
};

export default CustomTable;
